/* eslint-disable no-undef */
// Preview builds are served from an arbitrary sub-path: resolve lazy chunks relative to the main script.
const src = document.currentScript && document.currentScript.src;
if (src) __webpack_public_path__ = src.replace(/static\/js\/[^/]*$/, "");
